import { createApp } from "vue";
import "./modal.less";

let timer: NodeJS.Timeout, timer1: NodeJS.Timeout, timer2: NodeJS.Timeout;

const Toast = {
  show(message: string, duration = 3) {
    const t = document.querySelector(".m-toast");
    if (t) t.remove();
    clearTimeout(timer);
    clearTimeout(timer1);
    clearTimeout(timer2);
    const div = document.createElement("div");
    const el = document.createElement("div");
    div.className = "m-toast";
    div.appendChild(el);
    document.body.appendChild(div);
    div.style.opacity = "0";
    div.style.transition = "ease 300ms all";
    timer = setTimeout(() => {
      div.style.opacity = "0";
      timer1 = setTimeout(() => {
        document.body.removeChild(div);
      }, 300);
    }, duration * 1000);

    const app = createApp({
      data() {
        return {
          message,
        };
      },
      mounted() {
        timer2 = setTimeout(() => {
          div.style.opacity = "1";
        }, 100);
      },
      render() {
        return (
          <div class="m-toast-root">
            <div class="m-toast-wrap">
              <div class="m-toast">
                <div class="m-toast-content">
                  <div class="m-toast-message">{this.message}</div>
                </div>
              </div>
            </div>
          </div>
        );
      },
    });

    app.mount(el);
  },
};

export default defineNuxtPlugin(() => {
  const info = (msg: string, duration: number) => {
    Toast.show(msg, duration);
  };

  // 提供给 Nuxt app
  return {
    provide: {
      toast: {
        info,
        success: info,
        error: info,
        warn: info,
        show: Toast.show,
      },
    },
  };
});
